// extracted by mini-css-extract-plugin
module.exports = {"List":"ComponentBodyMagazineList_List__pjBAy","Text":"ComponentBodyMagazineList_Text__fqY2n"};